const appConfig = {
    apiUrl: '/api',
    useMockData: process.env.REACT_APP_USE_MOCK_DATA === 'true',
    entraClientId: process.env.REACT_APP_ENTRA_CLIENT_ID || '',
    entraTenantId: process.env.REACT_APP_ENTRA_TENANT_ID || '',
};

export default appConfig;
